const isProd = process.env.NODE_ENV === "production";
const useLiveServers = true;

const production = {
  lumin_host: "https://api.mylumin.net",
};

const localDevelopment = {
  lumin_host: "http://localhost:3333",
};

const settings = isProd || useLiveServers ? production : localDevelopment;

export const AUTH_CONFIG = {
  domain: "https://auth.prod.mylumin.net",
};

export const APP_URL = isProd ? 'https://videochat.mylumin.net' : 'http://localhost:3000';

export const PRODUCTION_LUMIN_HOST = "https://api.mylumin.net";
export const LUMIN_HOST = settings.lumin_host;
